import {client} from '../helpers/api';

export async function postRequestFreeTrial({gradeId, kidId}) {
  const body = {grade_id: gradeId, kid_id: kidId};

  const response = await client.post('/api/request-free-trial', body);

  if (response.data?.status) {
    return response.data?.message || 'Success';
  } else if (response.data?.status === false) {
    throw response.data?.message || '';
  }
  throw response;
}
